<template>
    <projects-module-component/>
</template>

<script>
    import ProjectsModuleComponent from "@/components/admin/ProjectsModuleComponent";
    
    export default {
        name: "ProjectsModule",
        title: "Proyectos | Equity Baja",
        components: {ProjectsModuleComponent}
    }
</script>

<style scoped>

</style>